import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import SidebarToggle from './SidebarToggle';
import SidebarBackdrop from './SidebarBackdrop';
import MobileHeader from './MobileHeader';
import DesktopHiddenBar from './DesktopHiddenBar';
import { SidebarProvider, useSidebar } from '../../contexts/SidebarContext';
import { SupportChatProvider } from '../../contexts/SupportChatContext';
import { AgentChatProvider } from '../../contexts/AgentChatContext';
import ChatFAB from '../SupportChat/ChatFAB';
import ChatPanel from '../SupportChat/ChatPanel';
import '../SupportChat/SupportChat.css';
import CRMPhoneWidget from '../Telephony/CRMPhoneWidget';
import { usePermissions } from '../../utils/usePermissions';
import { TelephonyAgentEventsProvider } from '../../contexts/TelephonyAgentEventsContext';
import { CallWindowRoot } from '../Telephony/CallWindow';
import TelephonySubjectNavigator from '../Telephony/TelephonySubjectNavigator';
import { CallQueueProvider } from '../../contexts/CallQueueContext';
import CallQueuePanel from '../Telephony/CallQueuePanel';
import { useCallQueueShortcuts } from '../../hooks/useCallQueueShortcuts';
import { useOverdueNotifications } from '../../hooks/useOverdueNotifications';
import PracticeSandboxBanner from '../Academy/Banner/PracticeSandboxBanner';

const LayoutContent: React.FC = () => {
  const { hasPermission } = usePermissions();
  const { isMobile, isMobileOpen, closeMobile, isDesktopOverlayOpen, closeDesktopOverlay } = useSidebar();
  const featureEnabled = String(import.meta.env.VITE_CRM_PHONE_ENABLED ?? 'false').toLowerCase() === 'true';
  const canSeePhoneWidget = featureEnabled && hasPermission('telephony:panel:view');

  // Подключаем хуки для очереди звонков
  useCallQueueShortcuts();
  useOverdueNotifications();
  // AB3 Academy: recovery sandbox-сессии вызывается на странице плеера
  // (AcademyModulePlayerPage) только для practice-модуля — там известен тип.

  return (
    <div className="app-shell">
      {/* AB3 Academy: глобальный banner режима практики — полоса над рабочей
          областью, вне row-флекса app-layout (иначе лёг бы колонкой слева).
          Рендерит null когда practice неактивна — ноль влияния на остальных. */}
      <PracticeSandboxBanner />
      <div className="app-layout">
        {canSeePhoneWidget && <CRMPhoneWidget />}
        <SidebarBackdrop isVisible={(isMobile && isMobileOpen) || (!isMobile && isDesktopOverlayOpen)} onClick={isMobile ? closeMobile : closeDesktopOverlay} />
        <Sidebar />
        <SidebarToggle />
        <main className="main-content">
          <MobileHeader />
          <DesktopHiddenBar />
          <Outlet />
        </main>
        {canSeePhoneWidget && <CallWindowRoot />}
        {canSeePhoneWidget && <TelephonySubjectNavigator />}
        {canSeePhoneWidget && <CallQueuePanel />}
        <ChatFAB />
        <ChatPanel />
      </div>
    </div>
  );
};

const Layout: React.FC = () => {
  const { hasPermission } = usePermissions();
  const featureEnabled = String(import.meta.env.VITE_CRM_PHONE_ENABLED ?? 'false').toLowerCase() === 'true';
  const canSeePhoneWidget = featureEnabled && hasPermission('telephony:panel:view');

  return (
    <SidebarProvider>
      <SupportChatProvider>
        <AgentChatProvider>
          {canSeePhoneWidget ? (
            <TelephonyAgentEventsProvider>
              <CallQueueProvider>
                <LayoutContent />
              </CallQueueProvider>
            </TelephonyAgentEventsProvider>
          ) : (
            <LayoutContent />
          )}
        </AgentChatProvider>
      </SupportChatProvider>
    </SidebarProvider>
  );
};

export default Layout;
